
<div class="container declarations" style="max-width:1250px;">
  <div style="background-color:whitesmoke;">
    <div style="padding: 40px 35px 40px 40px">
      <h3 style="font-weight: 300;">Déclaration des équivalences</h3>
      <p>Les équivalences peuvent être analysées et reconnues automatiquement par Charlemagne ou transmises manuellement :</p>
      <ol>
        <li style="margin-bottom: 15px !important;font-weight: bold;">
          <p class="p-li">
            <strong>D’une AEP vers une autre AEP – transmission manuelle</strong>
          </p>
          <p class="p-li">
            Exemple : un élève a déjà son AEP en soudage semi-automatique GMAW-FCAW (4250) et désire s’inscrire à l’AEP en préparation de matériaux métalliques (4252).
          </p>
          <p class="p-li">
            <img src="../../../assets/images/PageDeclarations_Capture1.png" style="max-width:100%;" />
          </p>
          <p class="p-li">
            Le candidat se verra donc reconnaître 4 compétences. Celles-ci devront être transmises manuellement.
          </p>
        </li>
        <li style="margin-bottom: 15px !important;font-weight: bold;">
          <p class="p-li">
            <strong>D’un DEP vers une AEP – transmission manuelle</strong>
          </p>
          <p class="p-li">
            Exemple : un élève a déjà son DEP en secrétariat (5357) et désire s’inscrire à l’AEP en secrétariat dentaire (4235).
          </p>
          <p class="p-li">
            <img src="../../../assets/images/PageDeclarations_Capture2.png" style="max-width:100%;" />
          </p>
          <p class="p-li">
            Le candidat se verra donc reconnaître 3 compétences. Celles-ci devront être transmises manuellement.
          </p>
        </li>
        <li style="margin-bottom: 15px !important;font-weight: bold;">
          <p class="p-li">
            <strong>D’une AEP vers un DEP – transmission automatique</strong>
          </p>
          <p class="p-li margin-bottom">
            Exemple : un élève a déjà son AEP en assemblage de meubles (4207) et désire s’inscrire au DEP en ébénisterie (5352).
          </p>
          <p class="p-li">
            Le candidat pourrait se voir reconnaître des compétences équivalentes. Pour les connaître, il faut consulter le site du MEQ à l'adresse suivante :
            <a href="https://www.quebec.ca/education/formation-professionnelle-education-adultes/la-formation-professionnelle/documents-administratifs/equivalence" target="_blank">https://www.quebec.ca/education/formation-professionnelle-education-adultes/la-formation-professionnelle/documents-administratifs/equivalence</a>
          </p>
          <p class="p-li">
            Note : Il est possible qu'il y ait un délai entre le moment où l'équivalence est reconnue par le MEQ et son intégration au système Charlemagne. La transmission peut alors se faire de façon manuelle.
          </p>
        </li>
      </ol>
      <br />
      <hr />
      <p style="text-align: justify;">
        <strong>Note au professionnel :</strong><br />
        La décision de transmettre ou non une équivalence de compétence entre deux programmes d’études appartient au professionnel qui analyse le dossier d’un candidat lors de son inscription. Le contexte d’apprentissage dans lequel le candidat a atteint une compétence, les changements technologiques, le temps passé après avoir été évalué une première fois sont toutes des raisons qui pourraient influencer le choix professionnel de reconnaître ou non une équivalence.
      </p>
    </div>
  </div>

</div>
